import { render, staticRenderFns } from "./CampaignTaux.vue?vue&type=template&id=5b8f5bc4"
import script from "./CampaignTaux.vue?vue&type=script&lang=js"
export * from "./CampaignTaux.vue?vue&type=script&lang=js"
import style0 from "./CampaignTaux.vue?vue&type=style&index=0&id=5b8f5bc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports